import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "LIcense",
  "description": "",
  "published": "2007-05-22T00:00:00.000Z",
  "redirect_from": ["/blog/license/swizec/205"],
  "categories": "food for thought, linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Open source software is a very interesting thing and I love partaining in it beacuse it's quite simply free experience and learning to become better at what I do. A wonderful deal. It is very understandable that big corporations and some others aren't for open source adn are in fact very much against it. One has to agree, the job of youth is to rebel and the job of the big and powerful is to prevent rebellion.`}</p>
    <p>{`Having an open source project or two myself I was beginning to look into the licensing part of it. There are obvious problems with `}<a parentName="p" {...{
        "href": "http://www.opensource.org/licenses/gpl-license.php"
      }}>{`GPL`}</a>{` as it is a viral license in that it spreads and spreads much like herpes. Every time a project kisses another they instantly both have herpes.`}</p>
    <p>{`However there are many instances in my own use of my own projects where I directly violate GPL due to deals struck with clients in order to be paid for my work. I am after all developing something for a well defined client according to their specifications and needs. Even though I am allowed to eventually release this into the wild they do not want me to do so immediatelly.`}</p>
    <p>{`Projects are very difficult to develop when everything has to be buitl from the ground up, so I have some building blocks ready. Due to my own inexperience these are GPL'd and thus potentially dangerous. So far I have gone against the license in order to avoid too much danger, but this is wrong. What is there to do other than find another license you might ask? See, the problem is there are `}<a parentName="p" {...{
        "href": "http://www.opensource.org/licenses/category"
      }}>{`many licenses`}</a>{` and all almost completely nonunderstandable to me because they're filled with lawyer garble beyond my comprehension.`}</p>
    <p>{`The answer is thus to create my own license to fit my needs, but to do this I need someone to put it in lawyer speak. Those somethings cost a lot of money. Therein lies the problem.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      